import React from "react";
import { motion } from "framer-motion";
import DroneSVGWEB from "../../assets/DroneSVGWEB.svg";
import BackWeb from "../../assets/BackWeb.svg";
import { useTranslation } from "react-i18next";

const AssestEye = () => {
  const { t } = useTranslation();
  return (
    <section
      className="relative h-[60vh] md:h-[80vh] flex items-center justify-center text-center bg-bottom md:bg-center bg-no-repeat bg-cover"
      style={{
        backgroundImage: `url(${BackWeb})`,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto px-6"
      >
        {/* Logo */}
        <img
          src={DroneSVGWEB}
          alt="AssetEye Logo"
          className="mx-auto mb-6 w-[200px] md:w-[220px] h-auto"
        />

        {/* Tagline */}
        <p className="font-arya text-2xl md:text-4xl font-bold text-white mb-4">
          {t("assestEye.tagline.part1")} & <br /> {t("assestEye.tagline.part2")}
        </p>

        {/* Support line */}
        <p className="font-arya text-base md:text-xl font-semibold tracking-wide text-white uppercase">
          {t("assestEye.supportLine")}
        </p>
      </motion.div>
    </section>
  );
};

export default AssestEye;
